import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeftSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowLeftSquare"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M11 15.5L7.5 12L11 8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 12H8" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowLeftSquare;
